import {Box, Typography} from '@mui/material';
import React from 'react';

import {MainFooter, MainHeader, PageWrapperLayout} from 'presentation/components';
import {Filter} from 'presentation/components/Filter';
import {GuidesEnum} from 'presentation/constants';
import {DistrictSelection} from 'presentation/modules/guide/shared/ui/components/DistrictSelection';
import {FlowType} from 'presentation/pages/private/store/locationStore/constants';
import {StyledBreadcrumbs} from 'presentation/pages/private/uf-selection/styles';
import {translations} from 'presentation/translations-new';
import {Link} from 'react-router-dom';
import {useOdontoGuideDistricts} from './hooks/useOdontoGuideDistricts';
import {Container} from './styles';

const {
	searchDistrict,
	selectDistrict,
	city,
	state: stateName,
	district,
} = translations['pt-br'].commons;

export function OdontoGuideDistricts() {
	const {isMobile, pathCitySelection, handleClose, handleBack} = useOdontoGuideDistricts();

	return (
		<PageWrapperLayout title={selectDistrict}>
			<MainHeader
				title={selectDistrict}
				handleBack={handleBack}
				handleClose={handleClose}
				variant="subRoute">
				<StyledBreadcrumbs>
					<Link to={GuidesEnum.SERVICE_NETWORK_ODONTO_FLOW_UF}>
						<Typography
							variant="body1"
							fontWeight={600}
							color="white"
							sx={{textDecoration: 'underline'}}>
							{stateName}
						</Typography>
					</Link>
					<Link to={pathCitySelection}>
						<Typography
							variant="body1"
							fontWeight={600}
							color="white"
							sx={{textDecoration: 'underline'}}>
							{city}
						</Typography>
					</Link>
					<Typography variant="body1" color="white">
						{district}
					</Typography>
				</StyledBreadcrumbs>
				<Filter.Root>
					<Filter.Search placeholder={searchDistrict} />
				</Filter.Root>
			</MainHeader>

			<Container>
				<DistrictSelection flowType={FlowType.ODONTO_GUIDE} />
			</Container>
			<Box mt="auto">
				<MainFooter customMarginBottom={isMobile ? '130px' : undefined} />
			</Box>
		</PageWrapperLayout>
	);
}
